/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для различных персональных рекомендаций.
   */
  app.PersonalRecommendationsView = app.View.extend({
    el: '.recommended-items',
    template: '#personal-recommendations-template',
    additionalOptions: [
      'algo',
      'search',
      'isProductRecommended',
      'noInitialFetch',
      'title',
      'mainWindow',
      'withDisinterestBtn',
      'itemsLimit',
      'cartItem',
      'bodyView',
      'isCart',
    ],
    title: 'Обратите внимание',
    withoutCarousel: false,

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.listenTo(app.currencies, 'change:current', this.fetchNewPrices);
      this.listenTo(this.model, 'sync', this.render);
      if (!this.noInitialFetch) {
        this.listenTo(this.mainWindow, 'window.scroll', _.throttle(this.shouldInitialise, 100));
        this.shouldInitialise();
      }
    },

    /**
     * Первоначальный запрос товаров
     */
    initFetch: function () {
      this.model.fetch();
    },

    /**
     * Инициализация наблюдателя ОКО
     * @param {Object} el Товар
     * @param {Object} model Модель товара
     */
    initOkoWatcher: function (el, model) {
      if (this.algo) {
        this.childViews.okoWatcher = new app.OkoWatcher(app.OKO_WATCHER_GET_DATA(
          el || this.el,
          app.OKO_WATCHER_GET_OBJECT_WITH_ALGO(this.algo),
          this.algo,
          model || this.model,
          this.mainWindow
        ));
      }
    },

    /**
     * Проверяет нужно ли инициализировать первоначальный запрос товаров
     */
    shouldInitialise: function () {
      if (app.helpers.DomHelper.isElementInViewport(this.$el, 350)) {
        this.stopListening(this.mainWindow, 'window.scroll');
        this.$el.addClass('not_display');
        this.initFetch();
      }
    },

    /**
     * Рендер рекомендаций
     */
    render: function () {
      var model = this.model.toJSON(),
        title = this.getTitle(),
        items = this.model instanceof app.Collection ? model : model.items;
      if (items && items.length > 0 && !this.isNeedToHIde) {
        if (typeof this.itemsLimit !== 'undefined' && items.length > this.itemsLimit) {
          items = _.take(items, this.itemsLimit);
        }
        this.$el.html(this.template({
          recommendedItems: items,
          title: title,
          withDisinterestBtn: this.withDisinterestBtn,
        }));
        this.$el.removeClass('not_display');
      } else {
        this.$el.html('');
        this.$el.addClass('not_display');
      }
      var recommendationElement = this.$('.recommendation-list');
      if (recommendationElement.length) {
        this.recommendationsCarouselView = new app.RecommendationsCarouselView({
          el: recommendationElement,
          withoutCarousel: this.withoutCarousel,
          items: items || null,
          cart: this.cart,
          algo: this.algo,
          user: this.user,
          settlement: this.settlement,
          isCart: this.isCart,
        });
      }
      if (this.childViews.okoWatcher) {
        this.childViews.okoWatcher.updateWatcher();
      } else {
        this.initOkoWatcher();
      }
    },

    /**
     * Формирование тайтла для шаблона
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Достаем новые цены после смены валюты
     * @param {Object} currency - обьект данных текущей валюты
     */
    fetchNewPrices: function (currency) {
      this.model.fetch({
        data: {
          currency: currency.get('name')
        }
      });
    },
  });
})(jQuery);

}.call(window));